// components/StampRewardForm.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import CouponPreview from './CouponPreview';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 5000,
});

const StampRewardForm = () => {
  const { restaurantId } = useParams();
  const [rewardRules, setRewardRules] = useState([
    { stampCount: 0, reward: '' },
  ]);
  const [stampSettings, setStampSettings] = useState({
    enabled: false,
    cooldownPeriod: 24,
  });

  useEffect(() => {
    fetchStampRewards();
    fetchStampSettings();
  }, []);

  //   const token = localStorage.getItem('ownerToken');
  //   const [welcomeResponse, restaurantResponse] = await Promise.all([
  //     api.get(`/restaurants/${restaurantId}/welcome-text`, {
  //       headers: { Authorization: `Bearer ${token}` },
  //     }),
  //     api.get(`/restaurants/${restaurantId}`, {
  //       headers: { Authorization: `Bearer ${token}` },
  //     }),
  //   ]);

  const fetchStampRewards = async () => {
    try {
      const token = localStorage.getItem('ownerToken');

      const response = await api.get(
        `/restaurants/${restaurantId}/stamp-rewards`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setRewardRules(response.data);
    } catch (error) {
      toast.error('Failed to fetch stamp rewards');
    }
  };

  const fetchStampSettings = async () => {
    try {
      const token = localStorage.getItem('ownerToken');

      const response = await api.get(
        `/restaurants/${restaurantId}/stamp-settings`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setStampSettings(response.data.stampSettings);
    } catch (error) {
      toast.error('Failed to fetch stamp settings');
    }
  };

  const handleAddReward = () => {
    setRewardRules([...rewardRules, { stampCount: 0, reward: '' }]);
  };

  const handleInputChange = (index, field, value) => {
    const newRewardRules = [...rewardRules];
    newRewardRules[index][field] = value;
    setRewardRules(newRewardRules);
  };

  const handleSettingsChange = (field, value) => {
    setStampSettings({ ...stampSettings, [field]: value });
  };

  const handleSubmit = async () => {
    try {
      const token = localStorage.getItem('ownerToken');

      // Update stamp settings
      await api.put(
        `/restaurants/${restaurantId}/stamp-settings`,
        stampSettings,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // Update stamp rewards
      await api.post(
        `/restaurants/${restaurantId}/stamp-rewards`,
        rewardRules,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      toast.success('Stamp rewards and settings updated successfully');
    } catch (error) {
      toast.error('Failed to update stamp rewards and settings');
    }
  };

  return (
    <div className='p-6'>
      <h2 className='text-2xl font-bold mb-4'>Setup Restaurant Rewards</h2>
      <h3 className='text-xl mb-4'>
        To use stamp, you need to purchase the nfc tag. For instructions,
        download our guide: ____.pdf
      </h3>

      <div className='mb-4'>
        <h3 className='text-lg font-bold mb-2'>Stamp Settings</h3>
        <label className='block mb-2'>
          <input
            type='checkbox'
            checked={stampSettings.enabled}
            onChange={(e) => handleSettingsChange('enabled', e.target.checked)}
            className='mr-2'
          />
          Enable Stamp Feature
        </label>
        <label className='block mb-2'>
          Cooldown Period (hours):
          <input
            type='number'
            value={stampSettings.cooldownPeriod}
            onChange={(e) =>
              handleSettingsChange('cooldownPeriod', e.target.value)
            }
            className='ml-2 p-1 border rounded'
          />
        </label>
      </div>

      <h3 className='text-lg font-bold mb-2'>Reward Rules</h3>
      {rewardRules.map((rule, index) => (
        <div key={index} className='mb-4'>
          <input
            type='number'
            placeholder='Stamp Count Ex:40'
            value={rule.stampCount}
            onChange={(e) =>
              handleInputChange(index, 'stampCount', e.target.value)
            }
            className='w-full mb-2 p-2 border rounded'
          />
          <input
            type='text'
            placeholder='Reward/Coupon Description Ex:Free Chicken'
            value={rule.reward}
            onChange={(e) => handleInputChange(index, 'reward', e.target.value)}
            className='w-full mb-2 p-2 border rounded'
          />
          <CouponPreview content={rule.reward} />
        </div>
      ))}
      <button
        onClick={handleAddReward}
        className='w-full bg-green-500 text-white p-2 rounded mb-4'
      >
        Add Another Reward
      </button>

      <button
        onClick={handleSubmit}
        className='w-full bg-blue-500 text-white p-2 rounded'
      >
        Submit
      </button>
    </div>
  );
};

export default StampRewardForm;
